import styled from 'styled-components';
import AuthLoader from '@lendi-ui/auth-loader';

export const Spinner = styled(AuthLoader)`
  position: absolute;
  z-index: 1;
`;
